import axios from 'axios';

export const getWordpressPage = pageId => {
  return axios.get(`${process.env.REACT_APP_BUSRATES_BLOG_ROOT_URL}/wp-json/wp/v2/pages/${pageId}?_embed`);
};